import { flatMap, pluck } from 'fxjs/es';

export function getUpcsIdsFromUserProducts({ user_products }) {
  return flatMap(
    ({ _: { up_cs } = {} }) => flatMap(({ _: { up_c_ss } = {} }) => pluck('id', up_c_ss), up_cs),
    user_products,
  );
}
